<div class="c-progress">
	<div class="c-svg-container progress-chart" #svgContainer></div>
</div>
